import {
  clearGetAmenitiesByGroupId,
  clearGetPackagesByGroupId,
  getAllGroups,
} from "../../../Redux/Groups/GroupsActions";
import { ColDef, GridReadyEvent, ICellRendererParams } from "ag-grid-community";
import Loading from "../../../Components/Common/Loading/Loading";
import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import exportToExcel from "../../../Util/exportToExcel";
import { AppDispatch } from "../../../Redux/store";
import React, { useEffect, useState } from "react";
import { RootState } from "../../../Redux/store";
import { Link, useNavigate } from "react-router";
import { HiDotsVertical } from "react-icons/hi";
import { IoCloseSharp } from "react-icons/io5";
import { AgGridReact } from "ag-grid-react";
import styles from "./Groups.module.scss";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

interface GroupsType {
  id: number;
  groupName: string;
}

const defaultColDef: ColDef = {
  resizable: true,
  sortable: true,
  filter: false,
  wrapText: true,
  autoHeight: true,
  unSortIcon: true,
};

function Groups() {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { allGroups, allGroupsLoading } = useSelector(
    (state: RootState) => state.groups,
  );
  const [rowData, setRowData] = useState<GroupsType[]>([]);
  const [gridApi, setGridApi] = useState<any>(null);
  const [search, setSearch] = useState("");
  // const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  // const [deleteGroupId, setDeleteGroupId] = useState<number>(-1);

  const onGridReady = (params: GridReadyEvent) => {
    setGridApi(params?.api);
    params?.api?.sizeColumnsToFit();
  };

  const columnDefs: ColDef<GroupsType>[] = [
    {
      headerName: "Group ID",
      field: "id",
      flex: 1,
      minWidth: 150,
    },
    {
      headerName: "Group Name",
      field: "groupName",
      flex: 1,
      minWidth: 150,
    },
    {
      sortable: false,
      suppressAutoSize: true,
      suppressMovable: true,
      suppressNavigable: true,
      editable: false,
      cellStyle: {
        pointerEvents: "all",
        userSelect: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
      },
      cellRenderer: (params: ICellRendererParams) => {
        return (
          <div className={styles.iconContainer}>
            <Menu
              direction="left"
              menuButton={
                <MenuButton>
                  <HiDotsVertical className={styles.icon} />
                </MenuButton>
              }
              transition
              portal
            >
              <MenuItem
                onClick={() =>
                  navigate(`/admin/groups/edit/${params?.data?.id}`)
                }
              >
                Edit
              </MenuItem>
              {/* <MenuItem
                onClick={() => {
                  setIsDeleteModalOpen(true);
                  setDeleteGroupId(params?.data?.id);
                }}
              >
                Delete
              </MenuItem> */}
            </Menu>
          </div>
        );
      },
    },
  ];

  const filteredRowData = rowData?.filter((row) => {
    return row?.groupName?.toLowerCase()?.includes(search?.toLowerCase());
  });

  // const deleteGroupConfirmationHandler = () => {
  //   const successHandler = () => {
  //     setIsDeleteModalOpen(false);
  //     setDeleteGroupId(-1);
  //   };
  //   dispatch(deleteGroup({ id: deleteGroupId, successHandler }));
  // };

  useEffect(() => {
    if (!gridApi) return;

    const handleResize = () => {
      gridApi?.sizeColumnsToFit();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [gridApi]);

  useEffect(() => {
    dispatch(getAllGroups());

    return () => {
      dispatch(clearGetAmenitiesByGroupId());
      dispatch(clearGetPackagesByGroupId());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (allGroups) {
      setRowData(allGroups);
    }
  }, [allGroups]);

  if (allGroupsLoading) {
    return <Loading />;
  }

  return (
    <React.Fragment>
      {/* <ConfirmationModal
        isOpen={isDeleteModalOpen}
        setIsOpen={setIsDeleteModalOpen}
        onConfirm={deleteGroupConfirmationHandler}
        heading="Delete Group"
        text="Are you sure you want to delete this group?"
        loading={false}
      /> */}
      <div className={styles.mainContainer}>
        <div className={styles.topContainer}>
          <div className={styles.headingContainer}>
            <h1 className={styles.heading}>Manage Groups</h1>
          </div>
          <div className={styles.buttonContainer}>
            {filteredRowData?.length > 0 && (
              <button
                className={styles.button}
                onClick={() =>
                  exportToExcel({
                    data: filteredRowData || [],
                    fileName: "Groups",
                  })
                }
              >
                Export
              </button>
            )}
            <Link to="/admin/groups/add" className={styles.buttonContainer}>
              <button className={styles.button}>Add Group</button>
            </Link>
          </div>
        </div>
        <div className={styles.bodyContainer}>
          <div className={styles.searchContainer}>
            <input
              type="text"
              className={styles.input}
              placeholder="Group"
              value={search}
              onChange={(e) => setSearch(e?.target?.value || "")}
            />
            <div className={styles.iconContainer} onClick={() => setSearch("")}>
              <IoCloseSharp className={styles.icon} />
            </div>
          </div>

          <div className={styles.gridContainer}>
            <AgGridReact
              className={styles.grid}
              rowData={filteredRowData}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              onGridReady={onGridReady}
              pagination={true}
              paginationPageSize={10}
              paginationPageSizeSelector={[5, 10, 20, 50, 100]}
              animateRows={true}
              domLayout="autoHeight"
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Groups;
